export const globalConfig = {
    //FONT_PROXY_PATH: 'http://192.168.111.45:9090/gjgzhjy',//前端(dev)项目地址
    //HOST_PROXY_ADMIN: 'http://192.168.111.45:8082/gjgzhjyhd',//后端(dev)项目地址
    FONT_PROXY_PATH: 'https://jw.sts.edu.cn/gjgzhjy',//前端(prod)项目地址
    HOST_PROXY_ADMIN: 'https://jw.sts.edu.cn/gjgzhjyhd',//后端(prod)项目地址
    //FONT_PROXY_PATH: 'https://gjg.jyszhzx.cn/gjgzhjy',//前端(test)项目地址
    //HOST_PROXY_ADMIN: 'https://gjg.jyszhzx.cn/gjgzhjyhd',//后端(test)项目地址
    CASSWITCH: true,
     CASURL: 'https://authserver.sts.edu.cn/authserver',//内部测试
    //CASURL: 'https://jw.sts.edu.cn/gjgcas',//学校（正式）
    // EAM_URL: 'http://192.168.111.39:8080/NHEAM',//老版本项目路径（本地）
    //PSWURL: 'http://192.168.111.45:9090/gjgzhjy/#/changePwd',//修改密码页面
    PSWURL: 'https://gjg.jyszhzx.cn/gjgzhjy/#/changePwd',
    //DOMIN: 'http://192.168.168.32:8082/gjgzhjy/',
    fileApi: '/api/file/',
    syncDataVisible: false,//数据同步按钮开关
    evaVersion: false,//验收版本开关
    auth: {
        admin: '1',//管理员
        xbzr: '2',//系部主任
        fgjxfzr: '3',//分管教学副主任
        jyszr: '4',//教研室主任
        rkjs: '5',//任课教师
        bzr: '6',//班主任
        fdy: '7',//辅导员
        xs: '8',//学生
        jwy_jx: '10',//教务员（教学）
        jwy_jc: '11',//教务员（教材）
        jwy_pk: '12',//教务员（排课）
        jwy_xx: '13',//教务员（选修）
        jwy_kw: '14',//教务员（考务）
        jwy_cj: '15',//教务员（成绩）
        jwy_pj: '16',//教务员（评教）
        jwy_sx: '17',//教务员（实习）
        jwy_wk: '18',//教务员（外考）
        jwy_qt: '20',//教务员（其他）
        sx_xbgly: '21',//系部管理员（实习）
        sx_zyzdjs: '22',//专业指导教师（实习）
        jsgl: '23',//教师管理
        xsgl: '24',//学生管理
        xyld: '25',//学院领导
        bysj_xbgly: '26',//系部管理员（毕业设计）
        bysj_zdjs: '27',//指导教师（毕业设计）
        kkbmzr: '28',//开课部门主任
    },
    courseArrange: {
        sportSiteCode: ['06'],//运动场类型代码
    },
    scoreManage: {
        teaChangeScoreConfig: true,//是否开放任课教师修改登分配置功能
        teaExemptStudyConfig: false,//是否开放任课教师免修/考设置功能
        passStandardConfig: false,//是否开放课程合格标准设置功能
        manualSubmitScore: false,//是否开放手动提交成绩功能
        examScoreConvert: true,//是否开启考查课程总评转换等第功能
    },
}

export const apiUrl = {
    srs: {
        // frontendUrl: 'https://res.xngczhxt.cn/',//前端项目地址
        // backendUrl: 'https://res.xngczhxt.cn/srs/',//后端项目地址
        // frontendUrl: 'https://tcas.xngczhxt.cn/srsv/',//体验服
        // backendUrl: 'https://tcas.xngczhxt.cn/srs/',
        systemid: 's3',//接口参数
        systemname: '%E8%99%9A%E6%8B%9F%E5%B7%A5%E5%8E%82',
        stoken: 'E0D50AFE-091D-4BF5-B369-E7D5CCF1D40E',
    },
    zhxt: {
        // frontendUrl: 'https://zhxt.xngczhxt.cn/',//正式
        // frontendUrl: 'https://tzhxt.xngczhxt.cn/',//体验
    },
}

export const oauth = {
    wechat: {
        authUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize?',
        // corpId: 'wwf8a4ab5a017d5a36',//测试
        // agentId: 1000008,
        // secret: '4Nc6sxHAV97n7bkQg-_p11M30LV35c8w6ukvEFdyiUY',
        corpId: 'wwa6ae0a5658927905',//正式
        agentId: 1000050,
        secret: 'A5adakHmpJ5bIdSCJokPs-0qJLIU1Hgqt-oV3e2hA8Q'
    }
}



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = 7
// module chunks = 502